export function computePrivateQueueEstimate(input) {
    const pretip = Math.max(0, input.preTipCoins ?? 0);
    const blockCoins = input.durationMinutes === null
        ? input.ratePerMinute * input.untimedDepositMinutes
        : Math.floor(input.ratePerMinute *
            input.durationMinutes *
            ((100 - input.discountPercent) / 100));
    const rateDeposit = input.queueDepositPercent > 0
        ? Math.max(1, Math.floor((blockCoins * input.queueDepositPercent) / 100))
        : 0;
    return {
        estimatedCoins: blockCoins + pretip,
        depositCoins: rateDeposit + pretip,
    };
}
export function formatPrivateDurationLabel(durationMinutes) {
    if (durationMinutes === null) {
        return 'Open-ended';
    }
    return `${String(durationMinutes)} min`;
}
export function formatPrivateDiscountLabel(discountPercent) {
    if (discountPercent <= 0) {
        return null;
    }
    return `${String(discountPercent)}% off`;
}
//# sourceMappingURL=privatePricing.js.map